<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        از تاریخ</label>
                    <Datepicker simple auto-submit id="from-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="fromDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <label><label style="color: red; height: 2px;" >*</label>
                        تا تاریخ</label>
                    <Datepicker simple auto-submit id="to-date" locale="fa" input-format="YYYY-MM-DD" :max="today" v-model="toDate" :locale-config="{
                        fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: {label: 'شمسی'}
                        }
                    }" />
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>شماره کارت</label>
                           <div class="input-group">
                                    <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                                    <span class="input-group-btn" v-if="pan && pan.replace(/-/g,'').length == 16"></span>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row" style="display: flex; justify-content:center ;">
                <div class="col-md-3" style="margin-top: 29px">
                    <button class="btn btn-primary btn-block" @click="submit" :disabled="!fromDate || !toDate">
                        <i class="si si-magnifier"></i>
                        جستجو
                    </button>
                </div>
            </div>
            <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
                <p class="mb-0">اطلاعاتی یافت نشد</p>
            </div>
            <hr v-if="rows.length">
            <table v-if="rows.length" class="table table-hover table-bordered mb-0" >
                <thead>
                    <tr>
                        <th>شماره کارت</th>
                        <th>مبلغ</th>
                        <th>شماره مرجع</th>
                        <th>زمان تراکنش</th>
                        <th>ساعت تراکنش</th>
                        <th>وضعیت</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row,index) in rows" :key="index">
                        <td>{{ row.cardNo }}</td>
                         <td>{{ row.amount ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(row.amount) : '0'}} ریال</td>
                        <td>{{ row.refrenceNumber }}</td>
                        <td>{{ row.chargeDate.replace(/\//g,'').slice(0,4) + '/' + row.chargeDate.replace(/\//g,'').slice(4,6) + '/' + row.chargeDate.replace(/\//g,'').slice(6,8) }}</td>
                         <td>{{ row.chargeTime }}</td>
                        <td v-if="row.isSuccess"><i class="ti-check text-success"></i></td>
                        <td v-else><i class="ti-close text-danger"></i></td>
                    </tr>
                </tbody>
            </table>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"><i class="icon ion-ios-arrow-forward"></i></a>
                        </li>
                        <li :class="currentPage == page ? 'page-item active' : 'page-item'" v-for="page in pages" :key="page">
                            <a class="page-link" href="#" v-on:click="currentPage = page">{{ page }}</a>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"><i class="icon ion-ios-arrow-back"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'CustomerReport',
    data(){
        return {
            showLoading: false,
            isSearched: false,
            rows: [],
            pan: this.$route.params.id,
            fromDate: '',
            today: moment().format('jYYYY-jMM-jDD'),
            toDate: '',
            currentPage: 1,
            pages: [1],
            perPage: 100,
            count: 0
        }
    },
    watch: {
        currentPage(value){
            this.currentPage = value;
            this.getData();
        },
        '$route.params.id':{
              handler: function() {
               this.pan= this.$route.params.id;
            }
        }
    },
    methods: {
        getData(){
            this.showLoading = true;
            const postedData = {
               fromdate: this.fromDate.replace(/\//g,''),
                todate: this.toDate.replace(/\//g,''),
                page: this.currentPage,
                perPage: this.perPage,
                cardNo: this.pan? this.pan.replace(/-/g,'') :"",
            };
            this.$router.replace({  params: {id: this.pan? this.pan.replace(/-/g,'') :""}})
            this.$api.post('/MosqueOrganization/ReturnChargeCardHistory',postedData).then(({data}) => {
                if(data.status && data.result){
                    this.rows = data.result.list;
                    this.count = data.result.totalCount;
                    let calcPages = Math.ceil((data.result.totalCount) / this.perPage);
                    calcPages = calcPages > 1 ? calcPages : 1
                    let pagesArray = [];
                    for(let i = 1;i <= calcPages;i++)
                        pagesArray.push(i);
                    this.pages = pagesArray;
                }
            }).finally(() => {
                this.isSearched = true;
                this.showLoading = false;
            });
        },
        submit(){
            this.getData();
        }
    },
}
</script>